import React from "react";
import { Box, useTheme } from "@mui/material";

interface EmptyPlaceholderCstProps {
  label?: React.ReactNode;
  minHeight?: string | number;
}

const EmptyPlaceholderCst: React.FC<EmptyPlaceholderCstProps> = ({
  label,
  minHeight = "72px",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "12px 16px",
        borderRadius: "12px",
        backgroundColor: theme.palette.background.card || "#2A2A2A",
        color: theme.palette.text.tertiary,
        fontSize: "13px",
        textAlign: "center",
      }}
    >
      {label}
    </Box>
  );
};

export default EmptyPlaceholderCst;
